export function copyToClipboard(sourceId) {
  const sourceElement = document.getElementById(sourceId);
  if (!sourceElement) {
    return;
  }
  const text =
    sourceElement.value !== undefined
      ? sourceElement.value
      : sourceElement.textContent;

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).catch(() => {
      fallbackCopy(sourceElement);
    });
    return;
  }
  fallbackCopy(sourceElement);
}

function fallbackCopy(sourceElement) {
  const wasReadOnly = sourceElement.readOnly;
  const isIOS = navigator.userAgent.match(/ipad|iphone/gi);
  // iOS ignores selection on readOnly fields, so make it editable while selecting.
  sourceElement.readOnly = false;
  if (isIOS) {
    const range = document.createRange();
    range.selectNodeContents(sourceElement);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    sourceElement.setSelectionRange(0, 999999);
  } else {
    sourceElement.select();
  }
  document.execCommand('copy');
  sourceElement.readOnly = wasReadOnly;
}